import React from 'react';
import Typography from '../typography/Typography';
import { ILoaderProps } from '../../types/loader';
import './loader.scss';

const Loader: React.FC<ILoaderProps> = ({
  size,
  height,
  dotsColor,
  className,
  fullScreen,
  fullComponent,
  text = 'Please wait!',
  spinner = false,
}) => {
  const classBase = 'custom-loader';

  const classes: string[] = [
    classBase,
    `${fullComponent ? `${classBase}-full-component` : ''}`,
    `${className || ''}`,
  ];

  const dotsClasses: string[] = [
    'loading-dots--dot',
    `${dotsColor ? `dots-color-${dotsColor}` : ''}`,
  ];

  const loader = (
    <div
      className={classes.join(' ')}
      data-testid={classBase}
      style={{
        width: size || '',
        height: size || height || '',
      }}
    >
      <div className="loading-dots w-12">
        <div
          data-testid="dot1"
          className={`${dotsClasses.join(' ')} m-r-5`}
        />
        <div
          data-testid="dot2"
          className={`${dotsClasses.join(' ')} m-r-5`}
        />
        <div data-testid="dot3" className={`${dotsClasses.join(' ')}`} />
      </div>
    </div>
  );

  if (fullScreen) {
    return (
      <>
        <div className="loader-content">
          {loader}
          <Typography className="margin-top-20" color="asphalt6" variant="h6">{text}</Typography>
        </div>
        <div className="loader-overlay" />
      </>
    );
  }

  if (spinner) {
    return <div className="spinner-loader" />;
  }
  return loader;
};

export default Loader;
